import {
	BreakoutroomData,
	BreakoutroomModel
} from 'models/program/BreakoutroomModel'
import {ProgramdayModel} from 'models/program/ProgramdayModel'
import {ProgramModel, ProgramNavigationItem} from 'models/program/ProgramModel'
import {Memoize} from 'util/memoize'

export type BreakoutData = {
	channel: 'breakout'
	url: string
	title: string
	start_time: string
	end_time: string
	children: Array<BreakoutroomData>
}

export type BreakoutParent = ProgramModel | ProgramdayModel

export class BreakoutModel {
	parent: BreakoutParent
	data: BreakoutData

	constructor(parent: BreakoutParent, data: BreakoutData) {
		this.parent = parent
		this.data = data
	}

	@Memoize()
	get day(): ProgramdayModel {
		return this.parent.day
	}

	@Memoize()
	get url(): string {
		return this.data.url
	}

	@Memoize()
	get program(): ProgramModel {
		return this.parent.program
	}

	@Memoize()
	get rooms(): Array<BreakoutroomModel> {
		return this.data.children.map(data => new BreakoutroomModel(this, data))
	}

	@Memoize()
	get navItems(): Array<ProgramNavigationItem> {
		return this.rooms.reduce(
			(res: Array<ProgramNavigationItem>, room) => [...res, ...room.navItems],
			[]
		)
	}

	@Memoize()
	get title(): string {
		return this.data.title
	}

	@Memoize()
	get start_time(): string {
		return this.data.start_time
	}

	@Memoize()
	get end_time(): string {
		return this.data.end_time
	}
}
